// src/components/ProjectModal.js
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button, Row, Col, notification } from 'antd';
import { AddOrUpdateCoatingRecord } from '../../../redux/Trackrecord/saga';
import moment from 'moment';

const ProjectModal = (props) => {

    const {
        isModalVisible,
        onClose,
        setIsModalVisible,
        projectDetailForm,
        isEdit,
        setIsEdit,
        editRecord,
        onfetchList,
        userName
    } = props;
    // const [form] = Form.useForm();
    //const [formData, setFormData] = useState({});
    const [addLoding, setAddLaoding] = useState(false)
    const [formData, setFormData] = useState({
        projectNo: '',
        contractor: '',
        client: '',
        project: '',
        system: '',
        startDate: '',
        linePipeDiameter: '',
        totalNoOfJoints: '',
        operatingTemp: '',
        factoryCoating: '',
        parentCoatingThickness: '',
        fjcDetails: '',
        coatingThickness: '',
        cwcThickness: '',
        cutbackLength: '',
        barge: '',
        country: '',
        onshoreOffshoreSpoolbase: '',
        fieldJointMaterials: {
            material1: '',
            material2: '',
            material3: ''
        },
        coatingThickness2: {
            thickness1: '',
            thickness2: '',
            thickness3: ''
        }
    });
    const parseJsonValue = (value) => {
        if (typeof value !== 'string') {
            return value;
        }

        try {
            return JSON.parse(value);
        } catch (error) {
            return value;
        }
    };
    const normalizeFieldJointMaterials = (value) => {
        const parsedValue = parseJsonValue(value);
        if (parsedValue && typeof parsedValue === 'object') {
            return {
                material1: parsedValue.material1 ?? '',
                material2: parsedValue.material2 ?? '',
                material3: parsedValue.material3 ?? ''
            };
        }

        return {
            material1: parsedValue ?? '',
            material2: '',
            material3: ''
        };
    };
    const normalizeCoatingThickness = (value) => {
        const parsedValue = parseJsonValue(value);
        if (parsedValue && typeof parsedValue === 'object') {
            return {
                thickness1: parsedValue.thickness1 ?? '',
                thickness2: parsedValue.thickness2 ?? '',
                thickness3: parsedValue.thickness3 ?? ''
            };
        }

        return {
            thickness1: parsedValue ?? '',
            thickness2: '',
            thickness3: ''
        };
    };
    const handleOk = async () => {
        // projectDetailForm.validateFields().then(async (values) => {
        //     // console.log(values)
        //     // setAddLaoding(true)

        //     // setAddLaoding(false)
        //     // setFormData(values);


        // });
        if (formData['project'] === '') {
            notification.warning({
                message: 'Enter the Project  to proceed!'
            });
            return;
        }
        if (isEdit) {
            formData['ID'] = editRecord.ID
            formData['created_date'] = moment().format('YYYY-MM-DD').toString()
        }
        else {

            formData['created_date'] = moment().format('YYYY-MM-DD').toString()
        }
        formData['created_by'] = userName ?? ''
        formData['isEdit'] = isEdit
        formData['fieldJointMaterials'] = normalizeFieldJointMaterials(formData.fieldJointMaterials)
        formData['coatingThickness2'] = normalizeCoatingThickness(formData.coatingThickness2)

        setAddLaoding(true)
        await AddOrUpdateCoatingRecord(formData)
        setAddLaoding(false)
        setIsEdit(false)
        setIsModalVisible(false);
        await onfetchList()
    };
    // useEffect(() => {
    //     console.log(formData)

    // }, [formData])
    useEffect(() => {
        if (isEdit && editRecord) {
            const normalizedRecord = {
                ...editRecord,
                fieldJointMaterials: normalizeFieldJointMaterials(editRecord.fieldJointMaterials),
                coatingThickness2: normalizeCoatingThickness(editRecord.coatingThickness2)
            };
            setFormData(normalizedRecord)
            projectDetailForm.setFieldsValue(normalizedRecord);
        }
        else {
            setFormData(formData)
            projectDetailForm.resetFields();

        }
        //console.log(isEdit, formData)

    }, [isEdit])

    const handleCancel = () => {
        projectDetailForm.resetFields();
        setIsEdit(false)

        setFormData({})
        onClose();
        setIsModalVisible(false)

    };
    const onValuesChange = (changedValues, allValues) => {
        // const edited = { ...formData };

        // Object.keys(changedValues).forEach((key) => {
        //     edited[key] = allValues;
        // }); 
        // console.log(allValues)
        // setEditedFields(edited);
        // setIsInputfeildChanged(true)
    };

    const handleInputChange = (name, value) => {
        // if (name === 'trailDate')
        //     value = moment(value).format('YYYY-MM-DD');



        setFormData((prevData) => ({ ...prevData, [name]: value }));

    };
    const handleNestedInputChange = (parentName, childName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [parentName]: {
                ...(prevData[parentName] || {}),
                [childName]: value
            }
        }));
    };
    return (
        <Modal
            width={1400}
            visible={isModalVisible}
            title=" Add New Coating Record"
            className="trackrecord-modal Tracker-modal"
            // onOk={handleOk}
            //onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk} loading={addLoding}>
                    {isEdit ? 'Update' : 'Submit'}
                </Button>,
            ]}
        >
            <Form form={projectDetailForm}
                name="project_form"
                layout="vertical"
                autoComplete="off"
                getcontainer={false}
                onValuesChange={onValuesChange}
                width={1400}
            >
                {/* Coating record fields matching the upload sheet */}
                <Row gutter={24}>
                  
                    <Col lg={5}>
                        <Form.Item name="projectNo" label="Project No.">
                            <Input onChange={(e) => handleInputChange('projectNo', e.target.value)} size="large" placeholder="Enter project number" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="contractor" label="Contractor">
                            <Input onChange={(e) => handleInputChange('contractor', e.target.value)} size="large" placeholder="Enter contractor" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="client" label="Client">
                            <Input onChange={(e) => handleInputChange('client', e.target.value)} size="large" placeholder="Enter client" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="project" label="Project">
                            <Input onChange={(e) => handleInputChange('project', e.target.value)} size="large" placeholder="Enter project" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="system" label="System">
                            <Input onChange={(e) => handleInputChange('system', e.target.value)} size="large" placeholder="Enter system" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="startDate" label="Start Date">
                            <Input onChange={(e) => handleInputChange('startDate', e.target.value)} size="large" placeholder="Enter start date" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="linePipeDiameter" label="Line Pipe Diameter">
                            <Input onChange={(e) => handleInputChange('linePipeDiameter', e.target.value)} size="large" placeholder="Enter line pipe diameter" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="totalNoOfJoints" label="Total No. of Joints">
                            <Input onChange={(e) => handleInputChange('totalNoOfJoints', e.target.value)} size="large" placeholder="Enter total joints" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="operatingTemp" label="Operating Temp">
                            <Input onChange={(e) => handleInputChange('operatingTemp', e.target.value)} size="large" placeholder="Enter operating temperature" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="factoryCoating" label="Factory Coating">
                            <Input onChange={(e) => handleInputChange('factoryCoating', e.target.value)} size="large" placeholder="Enter factory coating" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="parentCoatingThickness" label="Parent Coating Thickness">
                            <Input onChange={(e) => handleInputChange('parentCoatingThickness', e.target.value)} size="large" placeholder="Enter parent coating thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="fjcDetails" label="FJC Details">
                            <Input onChange={(e) => handleInputChange('fjcDetails', e.target.value)} size="large" placeholder="Enter FJC details" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="coatingThickness" label="Coating Thickness">
                            <Input onChange={(e) => handleInputChange('coatingThickness', e.target.value)} size="large" placeholder="Enter coating thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="cwcThickness" label="CWC Thickness">
                            <Input onChange={(e) => handleInputChange('cwcThickness', e.target.value)} size="large" placeholder="Enter CWC thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="cutbackLength" label="Cutback Length">
                            <Input onChange={(e) => handleInputChange('cutbackLength', e.target.value)} size="large" placeholder="Enter cutback length" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="barge" label="Barge">
                            <Input onChange={(e) => handleInputChange('barge', e.target.value)} size="large" placeholder="Enter barge" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="country" label="Country">
                            <Input onChange={(e) => handleInputChange('country', e.target.value)} size="large" placeholder="Enter country" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="onshoreOffshoreSpoolbase" label="Onshore / Offshore / Spoolbase">
                            <Input onChange={(e) => handleInputChange('onshoreOffshoreSpoolbase', e.target.value)} size="large" placeholder="Enter onshore/offshore/spoolbase" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name={['fieldJointMaterials', 'material1']} label="Field Joint Material 1">
                            <Input onChange={(e) => handleNestedInputChange('fieldJointMaterials', 'material1', e.target.value)} size="large" placeholder="Enter material 1" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name={['fieldJointMaterials', 'material2']} label="Field Joint Material 2">
                            <Input onChange={(e) => handleNestedInputChange('fieldJointMaterials', 'material2', e.target.value)} size="large" placeholder="Enter material 2" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name={['fieldJointMaterials', 'material3']} label="Field Joint Material 3">
                            <Input onChange={(e) => handleNestedInputChange('fieldJointMaterials', 'material3', e.target.value)} size="large" placeholder="Enter material 3" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name={['coatingThickness2', 'thickness1']} label="Coating Thickness 1">
                            <Input onChange={(e) => handleNestedInputChange('coatingThickness2', 'thickness1', e.target.value)} size="large" placeholder="Enter thickness 1" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name={['coatingThickness2', 'thickness2']} label="Coating Thickness 2">
                            <Input onChange={(e) => handleNestedInputChange('coatingThickness2', 'thickness2', e.target.value)} size="large" placeholder="Enter thickness 2" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name={['coatingThickness2', 'thickness3']} label="Coating Thickness 3">
                            <Input onChange={(e) => handleNestedInputChange('coatingThickness2', 'thickness3', e.target.value)} size="large" placeholder="Enter thickness 3" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ProjectModal;
